
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ReversePositionBadgeProps {
  isReverse?: boolean;
  size?: 'sm' | 'default';
}

export const ReversePositionBadge = ({ 
  isReverse = false, 
  size = 'default' 
}: ReversePositionBadgeProps) => {
  const { t } = useTranslation();

  if (!isReverse) return null;

  return (
    <Badge 
      variant="secondary" 
      className={`${size === 'sm' ? 'text-xs h-5' : ''} bg-orange-500/20 text-orange-700 hover:bg-orange-500/30 border-orange-500/30`}
    >
      <RotateCcw className={`${size === 'sm' ? 'h-2.5 w-2.5 mr-1' : 'h-3 w-3 mr-1'}`} />
      {t('reverse')}
    </Badge>
  );
};
